import { render, staticRenderFns } from "./SuppliersCategoriesAddSuppliers.vue?vue&type=template&id=6f9e2927"
import script from "./SuppliersCategoriesAddSuppliers.vue?vue&type=script&lang=js"
export * from "./SuppliersCategoriesAddSuppliers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f9e2927')) {
      api.createRecord('6f9e2927', component.options)
    } else {
      api.reload('6f9e2927', component.options)
    }
    module.hot.accept("./SuppliersCategoriesAddSuppliers.vue?vue&type=template&id=6f9e2927", function () {
      api.rerender('6f9e2927', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/supplier/categories/views/SuppliersCategoriesAddSuppliers.vue"
export default component.exports